var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9472 10.5995L11.6659 9.19326C11.5258 9.13352 11.37 9.12093 11.222 9.15739C11.0741 9.19385 10.942 9.27738 10.8456 9.39541L9.39245 11.1708C7.11187 10.0956 5.27652 8.26021 4.20124 5.97963L5.97667 4.52647C6.09493 4.43028 6.17864 4.29818 6.21512 4.15016C6.25159 4.00215 6.23885 3.84628 6.17882 3.70615L4.77254 0.42484C4.70666 0.273785 4.59013 0.150453 4.44305 0.0761123C4.29597 0.00177107 4.12756 -0.0189204 3.96686 0.0176058L0.919932 0.720743C0.764998 0.756521 0.626766 0.843757 0.527796 0.968214C0.428827 1.09267 0.374964 1.247 0.375 1.40601C0.375 8.92079 6.46593 15 13.969 15C14.1281 15.0001 14.2825 14.9463 14.407 14.8473C14.5315 14.7483 14.6188 14.6101 14.6546 14.4551L15.3577 11.4081C15.394 11.2467 15.3729 11.0776 15.2979 10.93C15.223 10.7824 15.099 10.6656 14.9472 10.5995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.741190ce98c1a7a1b46312c3bd62f8e7.svg";
export { ForwardRef as ReactComponent };